import { useState, useEffect, useRef } from "react";
import { Row, Col, Typography, Tabs, Form } from "antd";
import AnnouncementConfig from "@/config/announcement";
import ClassTimePeriodConfig from "@/config/classTimePeriod";
import { getLangList } from '@/lib/i18n';
import YearSemesterToolBar from "@/components/YearSemesterToolBar";
import ResponsiveTable from '@/components/responsiveTable';
import DrawerAnnouncement from "./DrawerAnnouncement";
import "./index.less";

const { getClassroomCountingPeople } = AnnouncementConfig;
const { getClassTimePeriods } = ClassTimePeriodConfig;
const { TabPane } = Tabs;

function Announcement() {
  const [isShowDrawer, setIsShowDrawer] = useState(false);
  const [selectedClassroom, setSelectedClassroom] = useState('');
  const [classCountingArray, setClassCountingArray] = useState([]);
  const [intervalArray, setIntervalArray] = useState([] as never as any);
  const [classCountingObject, setClassCountingObject] = useState({} as never as any);
  const [activeInterval, setActiveInterval] = useState('');
  const refreshApi = useRef<number>();
  const [yearSemesterForm] = Form.useForm();
  const announcementT: any = getLangList("announcement");

  const columns = [
    {
      title: announcementT.CLASSROOM,
      dataIndex: "classroom",
      render: (text: string) => <Typography.Link onClick={() => clickDrawer(text)}>{text}</Typography.Link>,
    },
    { title: announcementT.CLASS, dataIndex: "className" },
    { title: announcementT.SHOULD_ARRIVE, dataIndex: "totalStudent" },
    { title: announcementT.ACTUALLY_ARRIVE, dataIndex: "todaySignCount" },
    {
      title: announcementT.NOT_ARRIVE,
      dataIndex: "notArrive",
      className: 'not-arrive-count',
      render: (text: any, record: any) => record.totalStudent - record.todaySignCount,
    },
  ];

  useEffect(() => {
    return () => clearInterval(refreshApi.current);
  }, []);

  const getTimePeriodFunction = async (semesterId: number) => {
    return getClassTimePeriods({ semesterId }).then((res: any) => {
      const intervalArray = res?.value ?? [];

      setIntervalArray(intervalArray);
      return intervalArray;
    });
  };

  const getClassroomCountingPeopleFunction = async (semesterId: number) => {
    return getClassroomCountingPeople({ semesterId }).then((res: any) => {
      const classCountingObject = res?.value ?? {};

      setClassCountingObject(classCountingObject);
      return classCountingObject;
    });
  }

  const clickDrawer = (value: string = '') => {
    setIsShowDrawer(!isShowDrawer);
    setSelectedClassroom(value);
  }

  const onChangeTab = (key: string, resClassCountingObject: any = classCountingObject) => {
    setClassCountingArray(resClassCountingObject?.[key] ?? []);
    setActiveInterval(key);
  }

  return (
    <>
      <Row className="announcement-classroom" justify="center">
        <Col>
          <YearSemesterToolBar
            yearSemesterForm={yearSemesterForm}
            onChangeSemester={async (semesterId) => {
              clearInterval(refreshApi.current);
              Promise.all([getTimePeriodFunction(semesterId), getClassroomCountingPeopleFunction(semesterId)]).then((resArray) => {
                onChangeTab(resArray[0]?.[0]?.timePeriodName ?? '', resArray[1]);
              });
              refreshApi.current = window.setInterval(() => getClassroomCountingPeopleFunction(semesterId), 1000 * 6);
            }}
          />
        </Col>

        <Col span={24}>
          <Tabs
            size="large"
            type="card"
            activeKey={activeInterval}
            onChange={onChangeTab}
          >
            {intervalArray.map((item: any) => (
              <TabPane key={item.timePeriodName} tab={item.timePeriodName}>
                <ResponsiveTable
                  dataSource={classCountingArray}
                  columns={columns}
                  rowClassName={(record: any) => record.totalStudent - record.todaySignCount > 0 && 'not-arrive-row'}
                />
              </TabPane>
            ))}
          </Tabs>
        </Col>
      </Row>

      {isShowDrawer &&
        <DrawerAnnouncement
          clickDrawer={clickDrawer}
          selectedClassroom={selectedClassroom}
          semesterId={yearSemesterForm.getFieldsValue().semesterId}
        />
      }
    </>
  );
}

export default Announcement;